<script>
import {mapActions} from 'vuex'
import * as _ from 'lodash'
import MainList from '../MainList'
import {SHOW_TOAST_2} from '@/common/lib'

export default {
  name: "List",
  mixins: [
    MainList
  ],
  data() {
    return {
      isDisableFilterPanelSearch: false,
      columns: [
        {
          title: 'Thông tin',
          children: [
            {
              field: 'id',
              key: 'id',
              title: 'ID',
              align: 'center',
              width: 100
            },
            {
              field: 'name',
              key: 'name',
              title: 'Tên cấp tỉnh',
              align: 'left',
              width: 200,
              renderBodyCell: ({row, column}) => {
                return (
                  <CLink class="font-weight-bold"
                         onclick={() => this.openModalCreateOrUpdate('cc-modal-create-or-update', row)}>
                    {row[column.field]}
                  </CLink>
                )
              }
            }
          ]
        }
      ]
    }
  },
  async mounted() {
    await this.initDataList()
    if (this.$refs.ccVeTable) {
      await this.getDataTable()
      this.$refs.ccVeTable.showToastGetDataList('item cấp tỉnh')
    }
  },
  methods: {
    ...mapActions('common', ['getLocationAndZoneTypeList']),
    ...mapActions('province', ['initDataList', 'getDataList', 'createDataOther', 'updateDataOther', 'deleteDataOther']),
    async getDataTable() {
      this.$refs.ccVeTable && this.$refs.ccVeTable.loadingInstance && this.$refs.ccVeTable.loadingInstance.show()
      let _param = {
        filter: {}
      }
      const _filterMap = this.$refs.filterPanel.filterMap
      _.merge(_param['filter'], _filterMap)
      await this.getDataList(_param)
      this.$refs.ccVeTable && this.$refs.ccVeTable.loadingInstance && this.$refs.ccVeTable.loadingInstance.close()
    },
    async filterListWithCondition() {
      this.$refs.sidebarRightFilter.$refs.ccSidebar.hide()
      await this.getDataTable()
      this.$refs.ccVeTable.showToastGetDataList('item cấp tỉnh')
      if (this.deleteFailId && this.deleteFailId.length) {
        this.deleteFailId = []
        this.$refs.ccVeTable.unselectedAll()
      }
    },
    async deleteSelectedTable() {
      const _countItemDeleted = this.$refs.ccVeTable.dataTableSelected.length
      const confirm = window.confirm(`Bạn có chắc chắn muốn xóa ${_countItemDeleted} item cấp tỉnh?`)
      if (confirm) {
        if (this.$refs.ccVeTable.dataTableSelected && this.$refs.ccVeTable.dataTableSelected.length) {
          const res = await this.deleteDataOther(this.$refs.ccVeTable.dataTableSelected)
          if (res) {
            if (res === 'deleteDataOtherSuccess') {
              this.deleteFailId = []
              this.$refs.ccVeTable.unselectedAll()
              await Promise.all([
                this.getLocationAndZoneTypeList(),
                this.getDataTable()
              ])
              SHOW_TOAST_2('success', 'Xóa item cấp tỉnh thành công.')
            } else {
              this.deleteFailId = res.data['failed_ids']
              SHOW_TOAST_2('error', 'Không thể xóa item cấp tỉnh. Vui lòng thử lại!')
            }
          }
        }
      }
    },
    async onCreateItemOtherList() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const params = _.merge({}, this.formData)
        delete params.type

        const res = await this.createDataOther(params)
        if (res && res === 'createDataOtherSuccess') {
          this.closeModal()
          await this.$refs.filterPanel.resetCondition()
          await this.getDataTable()
          SHOW_TOAST_2('success', 'Thêm mới item cấp tỉnh thành công.')
        } else {
          SHOW_TOAST_2('error', 'Không thể thêm mới. Vui lòng thử lại!')
        }
      }
    },
    async onUpdateItemOtherList() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const params = _.merge({}, this.formData)
        delete params.type

        const res = await this.updateDataOther(params)
        if (res && res === 'updateDataOtherSuccess') {
          this.closeModal()
          await this.getDataTable()
          SHOW_TOAST_2('success', 'Cập nhật item cấp tỉnh thành công.')
        } else {
          SHOW_TOAST_2('error', 'Không thể cập nhật. Vui lòng thử lại!')
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
